<template>
  <div name="hres6ju-popup-approve" id="hres6ju-popup-approve" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal" ref="popupApproveModalButton">&times;</button>
          <h4 class="modal-title">{{ labels['HRES6JUC2']['0'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">
          <div class="detail detail-responsive">
            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['30'] }}</div>
              <div class="detail-right">
                <div class="detail-text width-70" id="coddesc_codappr" name="codappr">{{ approve.codappr }} - {{ approve.desc_codappr }}</div>
              </div>
            </div>
            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['40'] }}</div>
              <div class="detail-right">
                <div class="input-group width-70">
                  <hrms-datepicker  v-model="currentDate"
                                    v-show="false"
                                    v-validate="'required|date_format:DD/MM/YYYY'"
                                    data-vv-value-path="inputDate"
                                    name="currentDate"
                                    :has-error="errors.has('currentDate')" />

                  <hrms-datepicker  v-model="approve.dteappr"
                                    v-validate="'required|date_format:DD/MM/YYYY|after:currentDate'"
                                    data-vv-value-path="inputDate"
                                    name="dteappr"
                                    :has-error="errors.has('dteappr')" />
                  <div class="text-error" v-show="errors.has('dteappr')">{{errors.first('dteappr')}}</div>
                </div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['50'] }}</div>
              <div class="detail-right">
                <div class="detail-text width-70" id="desc_codtparg" name="desc_codtparg">{{ approve.desc_codtparg }}</div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['60'] }}</div>
              <div class="detail-right">
                <div class="input-group width-70">
                  <hrms-dropdown  v-model="approve.codcours"
                                  :options="arrCodcours[nowLang]"
                                  v-validate="approve.chk_appr === 'E' ? 'required' : ''"
                                  data-vv-value-path="inputValue"
                                  data-vv-name="codcours"
                                  :has-error="errors.has('codcours')" />
                  <div class="text-error" v-show="errors.has('codcours')">{{errors.first('codcours')}}</div>
                </div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['210'] }}</div>
              <div class="detail-right">
                <div class="input-group width-70">
                  <hrms-dropdown  v-model="approve.numclseq"
                                  :options="arrNumclseq[nowLang]"
                                  v-validate="'required'"
                                  data-vv-value-path="inputValue"
                                  data-vv-name="numclseq"
                                  :has-error="errors.has('numclseq')" />
                  <div class="text-error" v-show="errors.has('numclseq')">{{errors.first('numclseq')}}</div>
                </div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['70'] }}</div>
              <div class="detail-right">
                <div class="input-group width-70">
                  <hrms-dropdown  v-model="approve.codplan"
                                  :options="arrCodplan[nowLang]"
                                  v-validate="'required'"
                                  data-vv-value-path="inputValue"
                                  data-vv-name="codplan"
                                  :has-error="errors.has('codplan')" />
                  <div class="text-error" v-show="errors.has('codplan')">{{errors.first('codplan')}}</div>
                </div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['110'] }}</div>
              <div class="detail-right">
                <input type="number" class="input-text response-full-width width-70" id="dteyear" name="dteyear"
                                  v-model="approve.dteyear"
                                  maxlength="4"
                                  v-validate="'required|max:4'"
                                  data-vv-name="dteyear"
                                  :has-error="errors.has('dteyear')"
                                  :class="{ 'input-error' : errors.has('dteyear') }" />
                <div v-show="errors.has('dteyear')" class="text-error">{{ errors.first('dteyear') }}</div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['80'] }}</div>
              <div class="detail-right">
                <div class="detail-text width-70" id="dtetrbtw" name="dtetrst">{{ setDateOutput(approve.dtetrst) }} - {{ setDateOutput(approve.dtetren) }}</div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['120'] }}</div>
              <div class="detail-right">
                <div class="detail-text width-70" id="coddesc_codinsts" name="codinsts">{{ approve.codinsts }} - {{ approve.desc_codinsts }}</div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['130'] }}</div>
              <div class="detail-right">
                <div class="detail-text width-70" id="coddesc_codhotel" name="codhotel">{{ approve.codhotel }} - {{ approve.desc_codhotel }}</div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['140'] }}</div>
              <div class="detail-right">
                <div class="detail-text width-70" id="amtbudg" name="amtbudg">{{ approve.amtbudg }}</div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['150'] }}</div>
              <div class="detail-right">
                <div class="detail-text width-70" id="status" name="status">{{ approve.status }}</div>
              </div>
            </div>

            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES6JUC2']['190'] }}</div>
              <div class="detail-right">
                <textarea class="textarea-text width-70"
                          v-model="approve.remark"
                          id="remark"
                          name="remark"
                          maxlength="500"
                          v-validate="'max:500'"
                          data-vv-name="remark"
                          :has-error="errors.has('remark')" ></textarea>
                <div class="text-error" v-show="errors.has('remark')">{{errors.first('remark')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div>
              </div>
            </div>

          </div>
        </div>

        <div class="modal-footer align-center border-color-skin">
          <button type="button" class="btn bg-green" @click="validatePopupApprove()" ><i class="fa fa-check-circle"></i> {{ labelsButton['approve'] }}</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { constLabels } from 'assets/js/constLabels.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres6ju-popup-approve',
  data () {
    return {
      approve: {
        approvno: 0,
        staappr: '',
        flgStaappr: '',
        chk_appr: '',
        numseq: '',
        codempid: '',
        dtereq: '',
        codappr: '',
        desc_codappr: '',
        dteappr: '',
        codtparg: '',
        codcours: '',
        numclseq: '',
        codplan: '',
        dteyear: '',
        dtetrst: '',
        dtetren: '',
        codinsts: '',
        desc_codinsts: '',
        codhotel: '',
        desc_codhotel: '',
        amtbudg: '',
        status: '',
        remark: ''
      },
      currentDate: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    if (typeof this.arrCodcours[this.nowLang][this.approve.codcours] === 'undefined') {
      this.approve.codcours = ''
    }
    if (typeof this.arrCodplan[this.nowLang][this.approve.codplan] === 'undefined') {
      this.approve.codplan = ''
    }
  },
  watch: {
    'approve.dteyear' () {
      this.receivedHres6juNumclseq(this.approve)
      // this.approve.numclseq = 0
    },
    'approve.codcours' () {
      this.receivedHres6juNumclseq(this.approve)
      // this.approve.numclseq = 0
    },
    'approve.numclseq' () {
      if (typeof this.arrNumclseq[this.nowLang][this.approve.numclseq] === 'undefined') {
        this.approve.numclseq = 0
      }
      if (this.isPopupFirstLoad) {
        this.setPopupFirstLoad(false)
      } else {
        this.receivedHres6juCourseDetail(this.approve)
      }
    },
    courseDetail () {
      this.approve.codtparg = this.courseDetail.codtparg
      this.approve.desc_codtparg = this.courseDetail.desc_codtparg
      this.approve.codplan = this.courseDetail.codplan
      this.approve.dtetrst = this.courseDetail.dtetrst
      this.approve.dtetren = this.courseDetail.dtetren
      this.approve.codinsts = this.courseDetail.codinsts
      this.approve.desc_codinsts = this.courseDetail.desc_codinsts
      this.approve.codhotel = this.courseDetail.codhotel
      this.approve.desc_codhotel = this.courseDetail.desc_codhotel
      this.approve.amtbudg = this.courseDetail.amtbudg
    },
    detailSubmit () {
      this.approve = {
        approvno: this.indexSelected.approvno,
        staappr: this.indexSelected.staappr,
        flgStaappr: this.indexSelected.flgStaappr,
        chk_appr: this.indexSelected.chk_appr,
        numseq: this.indexSelected.numseq,
        codempid: this.indexSelected.codempid,
        dtereq: this.indexSelected.dtereq,
        codappr: this.codappr,
        desc_codappr: this.descCodappr,
        dteappr: moment().format('DD/MM/YYYY'),
        codtparg: this.indexSelected.codtparg,
        desc_codtparg: this.indexSelected.desc_codtparg + ' - ' + this.indexSelected.desc_codcours,
        codcours: this.indexSelected.codcours,
        codplan: this.chkCodplan(),
        numclseq: this.detailSubmit.numclseq.toString(),
        // codplan: this.indexSelected.codplan,
        dteyear: this.detailSubmit.dteyear,
        dtetrst: this.detailSubmit.dtetrst, //
        dtetren: this.detailSubmit.dtetren, //
        codinsts: this.detailSubmit.codinsts, //
        desc_codinsts: this.detailSubmit.desc_codinsts,
        codhotel: this.detailSubmit.codhotel, //
        desc_codhotel: this.detailSubmit.desc_codhotel,
        amtbudg: this.detailSubmit.amtbudg, //
        status: this.indexSelected.status,
        remark: ''
      }
      this.$nextTick(function () {
        this.errors.clear()
      })
    }
  },
  props: [ 'labels', 'nowLang', 'data', 'detailSubmit', 'arrCodcours', 'arrNumclseq', 'arrCodplan', 'postHres6juSendApprove', 'receivedHres6juCourseDetail', 'indexSelected', 'codappr', 'descCodappr', 'labelsButton', 'courseDetail', 'isPopupFirstLoad', 'setPopupFirstLoad', 'receivedHres6juNumclseq' ],
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    chkCodplan () {
      if (this.indexSelected.codplan === ' ') {
        return 'A'
      } else {
        return this.indexSelected.codplan
      }
    },
    validatePopupApprove () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres6juSendApprove(this.sendApprove())
        }
      })
    },
    sendApprove () {
      this.approve.numclseq = this.approve.numclseq.toString()
      return {
        approveParams: this.approve,
        referenceButton: this.$refs.popupApproveModalButton
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// popupApprove.vue?0ec50400